<script>
	const _ = require('underscore');
	const Vue = require('vue');

	module.exports = {
		props: ['articles', 'highlightWords', 'onCloseClick'],

		computed: {
			content() {
				let articles = this.articles;
				let list = [];

				if (articles && articles.length) {
					articles.forEach(a => {
						list.push(
							_.assign(
								{},
								{
									authors: this.getAuthors(a),
									title: a.title,
									content: this.getContent(a.content)
								}
							)
						);
					});
				}
				return list;
			}
		},
		methods: {
			getAuthors(article) {
				let authors = null;
				if (article && article.authors && article.authors.length) {
					authors = article.authors.join(', ');
				}
				return authors;
			},
			getContent(content) {
				let text = '';
				let highlightWords = this.highlightWords;
				if (content && content.length) {
					text = content;
					if (highlightWords && highlightWords.length) {
						highlightWords.forEach(word => {
							text = text.replace(new RegExp('\\b' + word + '(?![^<>]*>)\\b', 'gi'), '<span class="highlight">$&</span>');
						});
					}
				}
				return text;
			}
		},
		mounted() {
			Vue.nextTick(() => {
				this.$refs.closeButton.focus();
			});
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'config/variables';

	.article-overlay {
		background-color: $c-white;
		border: 1px solid $c-slate;

		.content {
			z-index: 4;
			position: absolute;
			top: 0;
			bottom: 0;
			left: 0;
			right: 0;
			overflow-y: scroll;

			.content-inner {
				margin: 0 auto;
				max-width: $max-width-inner;

				.article-content {
					margin: 2rem 0;
					padding: 2rem 0;
					border-bottom: 1px solid $c-grey;

					.highlight {
						background-color: $c-yellow;
					}
				}
			}
		}

		.close {
			position: absolute;
			right: 1rem;
			font-size: 3rem;
			line-height: 0.7;
			font-weight: bold;
			text-align: right;
			margin: 2rem;
			z-index: 5;
			color: $c-blue;

			&:hover {
				color: $c-slate-dark;
			}
		}
	}
</style>
<template>
	<div
		class="article-overlay"
		role="dialog"
		aria-label="Articles">
		<button
			class="button -link close"
			aria-label="Close article"
			ref="closeButton"
			@click="onCloseClick">
			×
		</button>
		<div class="content">
			<div class="content-inner">
				<div
					v-for="article in content"
					:key="article.title"
					class="article-content rte">
					<h1
						v-if="article.title"
						class="content-title">
						{{ article.title }}
					</h1>
					<div
						v-if="article.authors"
						class="font-small text-muted">
						by {{ article.authors }}
					</div>
					<div v-html="article.content"></div>
				</div>
			</div>
		</div>
	</div>
</template>
